const descriptions: Record<string, string> = {
  openid: "Identify your Froppio account",
  email: "Read your email address",
  profile: "Read your basic profile",
  phone: "Read your phone number",
};

export function OAuthScopes({ scopes }: { scopes: string[] }) {
  const unique = [...new Set(scopes.filter(Boolean))];
  return unique.length ? (
    <ul className="list-disc space-y-1 pl-5 text-sm">
      {unique.map(scope => <li key={scope}><span className="font-medium">{scope}</span>{descriptions[scope] && ` — ${descriptions[scope]}`}</li>)}
    </ul>
  ) : <p className="text-sm text-muted-foreground">No identity scopes requested.</p>;
}
